import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize } from 'rxjs/operators';
import { ToastService } from 'src/app/core';
import { DocumentUploadService } from 'src/app/core/document-upload.service';
import { nullSafe } from 'src/app/utils';
import { isNullOrUndefined } from '../../../app/core/utils';
import { LoaderService } from '../../core/loader.service';
import saveAs from 'file-saver';


@Component({
  selector: 'eos-exit-bulk-upload',
  templateUrl: './exit-bulk-upload.component.html',
  styleUrls: ['./exit-bulk-upload.component.css']
})
export class ExitBulkUploadComponent implements OnInit {

  @ViewChild('fileField') element: ElementRef;
  @ViewChild('fileControl') fileEle: ElementRef;
  selectedDocument: File;
  fileName: string;
  @Input() public submit: (invalidRecors: any, fileName, selectedDocument) => void;
  constructor(public modal: NgbActiveModal,
    private fileUploadService: DocumentUploadService,
    private toast: ToastService, private loader: LoaderService,
  ) { }

  ngOnInit() {
  }

  uploadDoc() {

    this.upload();
  }

  upload() {
    if (isNullOrUndefined(this.fileName)) {
      this.toast.warning("Please select the file");
      return;
    }
    this.loader.show();
    this.fileUploadService.ValidateIEBulkuploadTemplate(this.fileName, this.selectedDocument).pipe(finalize(() => {
      this.loader.clear();
    })).subscribe(resp => {
        if (resp.message.includes("valid")) {
        
          this.submit(resp.data, this.fileName, this.selectedDocument
          );
        } else {
          this.toast.error(resp.message);
          this.clearSelectedFile();
        }
      },
      (error) => {
        this.loader.clear();
          this.toast.error("Something went wrong!");
        });
  }


  fileSelected(files: FileList) {
   
    if (!files.item(0)) {
      return;
    }
   
    if(files.item(0).type!="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet")
    {
      this.toast.error("Invalid file type. Please select a valid file");
       this.clearSelectedFile();
      return;


    }

    this.selectedDocument = files.item(0);
    this.fileName = this.selectedDocument.name;



  }
  get selectedFileName(): string {
    return nullSafe(() => this.selectedDocument.name, '');
  }


  browseFile() {
    this.clearSelectedFile();
    this.fileEle.nativeElement.click();
  }

  clearSelectedFile() {
    this.fileEle.nativeElement.value = null;
    this.selectedDocument = null;
    this.element.nativeElement.value = "";
    this.fileName = null;
  }

  DownloadFile() {
    this.fileUploadService.downloadExitBulkuploadTemplate("Filename").subscribe(resp => {
      const extension = ".xlsx";
      const docName = "Upload_Template";
      saveAs(resp, `${docName}${extension}`);
    });
  }

}
